// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"b1-z","displaySixCardTiles":"c1-z"};